import React from 'react';

import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { selectLoggedInEmployeeData } from 'selectors/loggedInEmployee';
import { checkModuleEnabled } from 'utils/helpers/moduleAccess';
import { checkRoleAccess } from 'utils/helpers/rolesAccess';

import { routes } from 'constants/routes';

// After implementing Role Based Access control(RBAC), this component should be modified to be
// more generic and work with the logged in User access information
// so AdminRoute will be refactored to RoleAccessRoute

// Also the module access is also a part of this component which takes precedence in checking
// if the module is even enabled or not, and then check for role based access.

// suggestion: PrivateRoute, AdminRoute and this component could be merged in one.
function AdminOrManagerRoute({
  isManager,
  // userRoles,
  featureKey = null,

  component: Component,
  redirectionPath = routes.home,

  isAdminOrManagerRoute = false,
  roles = null,
  enabledFeatures,

  ...rest
}) {
  /* Role Access check */
  let userHasAccess = true;
  if (Array.isArray(roles)) {
    userHasAccess = roles.some((key) => checkRoleAccess(key, enabledFeatures));
  } else {
    userHasAccess = roles ? checkRoleAccess(roles, enabledFeatures) : true;
  }

  /* Module enabled check */
  let featureEnabled = true;
  if (Array.isArray(featureKey)) {
    featureEnabled = featureKey.some((key) => checkModuleEnabled(key));
  } else {
    featureEnabled = featureKey ? checkModuleEnabled(featureKey) : true;
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        ((isAdminOrManagerRoute && (isManager || userHasAccess)) || userHasAccess) && featureEnabled ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: redirectionPath, state: { referer: props.location } }} />
        )
      }
    />
  );
}

const mapStateToProps = (state, ownProps) => ({
  // userRoles: selectLoggedInEmployeeData(state).userRole,
  isManager: selectLoggedInEmployeeData(state).isHRISManager,
  enabledFeatures: selectLoggedInEmployeeData(state).enabledFeatures,
});

export default connect(mapStateToProps, null)(AdminOrManagerRoute);
